import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Storefront, Spinner, CheckCircle } from "@phosphor-icons/react";

// Se muestra al guardar un producto que quedó 100% listo pero aún no está en la tienda.
export default function PublishOfferDialog({ offer, onPublish, onSkip, busy }) {
  return (
    <Dialog open={!!offer} onOpenChange={(o) => { if (!o && !busy) onSkip(); }}>
      <DialogContent className="max-w-md" data-testid="publish-offer-dialog">
        <DialogHeader>
          <div className="h-11 w-11 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center mb-2">
            <CheckCircle size={24} weight="fill" className="text-emerald-600" />
          </div>
          <DialogTitle className="font-heading text-xl">¡Listo al 100% para la tienda!</DialogTitle>
          <DialogDescription>
            <b className="text-zinc-800">{offer?.name}</b> ya tiene foto, precio, slogan, uso ideal y ficha técnica completa. ¿Lo publicamos en la tienda en línea ahora?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button type="button" variant="outline" onClick={onSkip} disabled={busy} data-testid="publish-offer-skip">Ahora no</Button>
          <Button type="button" onClick={onPublish} disabled={busy} className="bg-[#002FA7] hover:bg-[#002277] text-white gap-1.5" data-testid="publish-offer-confirm">
            {busy ? <Spinner size={14} className="animate-spin" /> : <Storefront size={14} weight="fill" />} Publicar en la tienda
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
